(function () {
  'use strict';

  /*
    V3 uses a separate runtime key so this corrected dropdown controller
    can initialise even if an older Livvewell header script was already
    evaluated inside Shopify's Theme Editor.
  */
  if (window.LivvewellHeaderV3 && window.LivvewellHeaderV3.__loaded) {
    return;
  }

  var API = window.LivvewellHeaderV3 || {};
  API.__loaded = true;

  window.LivvewellHeaderV3 = API;
  window.LivvewellHeader = API;

  function shopRoot() {
    return (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) || '/';
  }

  function qs(root, selector) {
    return root ? root.querySelector(selector) : null;
  }

  function qsa(root, selector) {
    return root ? Array.from(root.querySelectorAll(selector)) : [];
  }

  function debounce(fn, wait) {
    var timer = null;

    return function () {
      var args = arguments;
      var context = this;

      clearTimeout(timer);

      timer = setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }

  function focusable(container) {
    if (!container) return [];

    return qsa(
      container,
      [
        'a[href]',
        'button:not([disabled])',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[tabindex]:not([tabindex="-1"])'
      ].join(',')
    ).filter(function (element) {
      return element.offsetParent !== null;
    });
  }

  function lockBody() {
    document.documentElement.classList.add('lw-header-lock');
    document.body.classList.add('lw-header-lock');
  }

  function unlockBodyIfPossible() {
    if (
      document.querySelector('.lw-header__search.is-open') ||
      document.querySelector('.lw-header__mobile.is-open')
    ) {
      return;
    }

    document.documentElement.classList.remove('lw-header-lock');
    document.body.classList.remove('lw-header-lock');
  }

  function Header(root) {
    if (!root || root.dataset.lwHeaderReady === 'true') {
      return;
    }

    root.dataset.lwHeaderReady = 'true';

    this.root = root;

    this.navItems = qsa(root, '[data-lw-nav-item]');
    this.search = qs(root, '[data-lw-search]');
    this.searchOpeners = qsa(root, '[data-lw-search-open]');
    this.searchClosers = qsa(root, '[data-lw-search-close]');
    this.searchInput = qs(root, '[data-lw-search-input]');
    this.searchResults = qs(root, '[data-lw-search-results]');
    this.searchDefault = qs(root, '[data-lw-search-default]');

    this.mobile = qs(root, '[data-lw-mobile]');
    this.mobileOpen = qs(root, '[data-lw-mobile-open]');
    this.mobileClosers = qsa(root, '[data-lw-mobile-close]');
    this.mobileSearch = qs(root, '[data-lw-mobile-search]');

    this.announcementItems = qsa(root, '[data-lw-announcement-item]');
    this.announcementPrev = qs(root, '[data-lw-announcement-prev]');
    this.announcementNext = qs(root, '[data-lw-announcement-next]');
    this.announcementIndex = 0;
    this.announcementTimer = null;

    this.productCarousels = qsa(root, '[data-lw-mega-product-carousel]');
    this.megaCarouselSpeed =
      parseInt(root.dataset.lwMegaCarouselSpeed, 10) || 4000;

    this.lastFocus = null;
    this.searchAbort = null;
    this.scrollTicking = false;

    /*
      Desktop mega-menu hover state.
      Only the real trigger and its own mega panel control hover.
    */
    this.megaCloseTimer = null;
    this.megaCloseDelay = 180;

    /*
      Closed dropdowns are removed from layout hit-testing with `hidden`
      and from focus/accessibility hit-testing with `inert`.
      No closed dropdown can ever receive a pointer event.
    */
    this.navItems.forEach(function (item) {
      item.dataset.lwMegaOpen = 'false';

      var mega = qs(item, '[data-lw-mega]');
      var trigger = qs(item, '[data-lw-mega-trigger]');

      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      }

      if (mega) {
        mega.hidden = true;
        mega.inert = true;
        mega.setAttribute('aria-hidden', 'true');
      }
    });

    this.bind();
    this.updateScrollState();
    this.startAnnouncementRotation();
  }

  Header.prototype.bind = function () {
    var self = this;

    this.navItems.forEach(function (item) {
      var trigger = qs(item, '[data-lw-mega-trigger]');
      var mega = qs(item, '[data-lw-mega]');
      var directLink = qs(item, '.lw-header__nav-link:not([data-lw-mega-trigger])');

      if (trigger && mega) {
        trigger.addEventListener('mouseenter', function (event) {
          if (!self.isDesktopHover()) return;

          /*
            Only a genuine pointer entry into this exact trigger can open
            the dropdown. Descendants / overlapping panels cannot proxy it.
          */
          if (event.currentTarget !== trigger) return;

          self.cancelMegaClose();
          self.openMega(item);
        });

        trigger.addEventListener('mouseleave', function () {
          if (!self.isDesktopHover()) return;

          self.scheduleMegaClose(item);
        });

        mega.addEventListener('mouseenter', function () {
          if (!self.isDesktopHover()) return;

          /*
            Important: entering a mega panel can KEEP its already-open
            menu open, but it can never OPEN a menu by itself.
          */
          if (item.dataset.lwMegaOpen === 'true') {
            self.cancelMegaClose();
          }
        });

        mega.addEventListener('mouseleave', function () {
          if (!self.isDesktopHover()) return;

          self.scheduleMegaClose(item);
        });

        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          self.cancelMegaClose();

          if (item.dataset.lwMegaOpen === 'true') {
            self.closeMega(item);
          } else {
            self.openMega(item);
          }
        });

        item.addEventListener('focusin', function () {
          self.cancelMegaClose();
        });

        item.addEventListener('focusout', function (event) {
          if (!item.contains(event.relatedTarget)) {
            self.closeMega(item);
          }
        });
      }

      if (directLink) {
        directLink.addEventListener('mouseenter', function () {
          if (!self.isDesktopHover()) return;

          self.cancelMegaClose();
          self.closeMega();
        });
      }
    });

    this.searchOpeners.forEach(function (button) {
      button.addEventListener('click', function () {
        self.openSearch(button);
      });
    });

    this.searchClosers.forEach(function (button) {
      button.addEventListener('click', function () {
        self.closeSearch();
      });
    });

    if (this.mobileOpen) {
      this.mobileOpen.addEventListener('click', function () {
        self.openMobile(self.mobileOpen);
      });
    }

    this.mobileClosers.forEach(function (button) {
      button.addEventListener('click', function () {
        self.closeMobile();
      });
    });

    if (this.mobileSearch) {
      this.mobileSearch.addEventListener('click', function () {
        self.closeMobile(false);

        window.setTimeout(function () {
          self.openSearch(self.mobileSearch);
        }, 120);
      });
    }

    if (this.searchInput) {
      this.searchInput.addEventListener(
        'input',
        debounce(function () {
          self.onSearchInput();
        }, 220)
      );
    }

    if (this.announcementPrev) {
      this.announcementPrev.addEventListener('click', function () {
        self.setAnnouncement(self.announcementIndex - 1);
        self.restartAnnouncementRotation();
      });
    }

    if (this.announcementNext) {
      this.announcementNext.addEventListener('click', function () {
        self.setAnnouncement(self.announcementIndex + 1);
        self.restartAnnouncementRotation();
      });
    }

    this.productCarousels.forEach(function (carousel) {
      carousel.style.setProperty(
        '--lw-carousel-count',
        carousel.dataset.slideCount || '1'
      );

      carousel.addEventListener('mouseenter', function () {
        self.stopProductCarousel(carousel);
      });

      carousel.addEventListener('mouseleave', function () {
        var mega = carousel.closest('[data-lw-mega]');
        var navItem = mega && mega.closest('[data-lw-nav-item]');

        if (navItem && navItem.dataset.lwMegaOpen === 'true') {
          self.startProductCarousel(carousel);
        }
      });

      carousel.addEventListener('focusin', function () {
        self.stopProductCarousel(carousel);
      });

      carousel.addEventListener('focusout', function (event) {
        if (carousel.contains(event.relatedTarget)) return;

        var mega = carousel.closest('[data-lw-mega]');
        var navItem = mega && mega.closest('[data-lw-nav-item]');

        if (navItem && navItem.dataset.lwMegaOpen === 'true') {
          self.startProductCarousel(carousel);
        }
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        self.closeMega();
        self.closeSearch();
        self.closeMobile();
      }

      if (event.key === 'Tab') {
        self.trapFocus(event);
      }
    });

    document.addEventListener('click', function (event) {
      if (!self.root.contains(event.target)) {
        self.closeMega();
      }
    });

    window.addEventListener(
      'scroll',
      function () {
        if (self.scrollTicking) return;

        self.scrollTicking = true;

        window.requestAnimationFrame(function () {
          self.updateScrollState();

          if (self.isDesktopHover()) {
            self.closeMega();
          }

          self.scrollTicking = false;
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      self.cancelMegaClose();
      self.closeMega();

      if (window.innerWidth > 980) {
        self.closeMobile();
      }
    });

    document.addEventListener('lw:cart:updated', function (event) {
      var cart =
        event &&
        event.detail &&
        event.detail.cart;

      if (cart) {
        self.updateCartCount(cart.item_count);
      }
    });

    document.addEventListener('lw:product-main:added', function () {
      self.syncCartCount();
    });

    document.addEventListener('lw:product-card:added', function () {
      self.syncCartCount();
    });
  };

  Header.prototype.isDesktopHover = function () {
    return (
      window.innerWidth > 980 &&
      window.matchMedia('(hover:hover) and (pointer:fine)').matches
    );
  };

  Header.prototype.cancelMegaClose = function () {
    if (this.megaCloseTimer) {
      window.clearTimeout(this.megaCloseTimer);
      this.megaCloseTimer = null;
    }
  };

  Header.prototype.scheduleMegaClose = function (item) {
    var self = this;

    this.cancelMegaClose();

    this.megaCloseTimer = window.setTimeout(function () {
      self.closeMega(item);
      self.megaCloseTimer = null;
    }, this.megaCloseDelay);
  };

  Header.prototype.openMega = function (item) {
    if (!item) return;

    var trigger = qs(item, '[data-lw-mega-trigger]');
    var mega = qs(item, '[data-lw-mega]');

    if (!trigger || !mega) return;

    this.cancelMegaClose();

    /*
      Close every other dropdown first.
      Closed menus are physically hidden, so they cannot overlap or
      steal the pointer from the currently-open menu.
    */
    this.navItems.forEach(function (other) {
      if (other === item) return;

      var otherTrigger = qs(other, '[data-lw-mega-trigger]');
      var otherMega = qs(other, '[data-lw-mega]');

      other.dataset.lwMegaOpen = 'false';

      if (otherTrigger) {
        otherTrigger.setAttribute('aria-expanded', 'false');
      }

      if (otherMega) {
        this.stopMegaProductCarousels(otherMega);

        otherMega.setAttribute('aria-hidden', 'true');
        otherMega.inert = true;
        otherMega.hidden = true;
      }
    }, this);

    item.dataset.lwMegaOpen = 'true';

    trigger.setAttribute('aria-expanded', 'true');

    /*
      Remove `hidden` before enabling interaction.
    */
    mega.hidden = false;
    mega.inert = false;
    mega.setAttribute('aria-hidden', 'false');

    this.startMegaProductCarousels(mega);
  };

  Header.prototype.closeMega = function (specificItem) {
    if (!specificItem) {
      this.cancelMegaClose();
    }

    var items =
      specificItem
        ? [specificItem]
        : this.navItems;

    items.forEach(function (item) {
      var trigger = qs(item, '[data-lw-mega-trigger]');
      var mega = qs(item, '[data-lw-mega]');

      item.dataset.lwMegaOpen = 'false';

      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      }

      if (mega) {
        this.stopMegaProductCarousels(mega);

        mega.setAttribute('aria-hidden', 'true');
        mega.inert = true;
        mega.hidden = true;
      }
    }, this);
  };

  Header.prototype.setProductCarouselSlide = function (carousel, index) {
    if (!carousel) return;

    var slides = qsa(carousel, '[data-lw-mega-product-slide]');
    var dots = qsa(carousel, '[data-lw-mega-product-dot]');
    var count = slides.length;

    if (!count) return;

    if (index < 0) index = count - 1;
    if (index >= count) index = 0;

    carousel.dataset.activeIndex = String(index);

    slides.forEach(function (slide, slideIndex) {
      var active = slideIndex === index;

      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');

      if (active) {
        slide.removeAttribute('tabindex');
      } else {
        slide.setAttribute('tabindex', '-1');
      }
    });

    dots.forEach(function (dot, dotIndex) {
      dot.classList.toggle('is-active', dotIndex === index);
    });
  };

  Header.prototype.advanceProductCarousel = function (carousel) {
    if (!carousel) return;

    var count = qsa(carousel, '[data-lw-mega-product-slide]').length;

    if (count < 2) return;

    var current =
      parseInt(carousel.dataset.activeIndex || '0', 10);

    this.setProductCarouselSlide(
      carousel,
      (current + 1) % count
    );
  };

  Header.prototype.startProductCarousel = function (carousel) {
    var self = this;

    if (!carousel) return;

    var slides = qsa(carousel, '[data-lw-mega-product-slide]');

    if (slides.length < 2) return;

    if (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      return;
    }

    this.stopProductCarousel(carousel);

    var carouselPosition =
      this.productCarousels.indexOf(carousel);

    var stagger =
      Math.max(0, carouselPosition) * 260;

    carousel._lwStartTimer = window.setTimeout(function () {
      self.advanceProductCarousel(carousel);

      carousel._lwTimer = window.setInterval(function () {
        self.advanceProductCarousel(carousel);
      }, self.megaCarouselSpeed);
    }, self.megaCarouselSpeed + stagger);
  };

  Header.prototype.stopProductCarousel = function (carousel) {
    if (!carousel) return;

    if (carousel._lwStartTimer) {
      window.clearTimeout(carousel._lwStartTimer);
      carousel._lwStartTimer = null;
    }

    if (carousel._lwTimer) {
      window.clearInterval(carousel._lwTimer);
      carousel._lwTimer = null;
    }
  };

  Header.prototype.startMegaProductCarousels = function (mega) {
    var self = this;

    qsa(mega, '[data-lw-mega-product-carousel]')
      .forEach(function (carousel) {
        self.startProductCarousel(carousel);
      });
  };

  Header.prototype.stopMegaProductCarousels = function (mega) {
    var self = this;

    qsa(mega, '[data-lw-mega-product-carousel]')
      .forEach(function (carousel) {
        self.stopProductCarousel(carousel);
      });
  };

  Header.prototype.openSearch = function (trigger) {
    if (!this.search) return;

    this.closeMega();
    this.closeMobile(false);

    this.lastFocus =
      trigger ||
      document.activeElement;

    this.search.classList.add('is-open');
    this.search.setAttribute('aria-hidden', 'false');

    this.searchOpeners.forEach(function (button) {
      button.setAttribute('aria-expanded', 'true');
    });

    lockBody();

    var self = this;

    window.setTimeout(function () {
      if (self.searchInput) {
        self.searchInput.focus();
      }
    }, 80);
  };

  Header.prototype.closeSearch = function (restoreFocus) {
    if (!this.search || !this.search.classList.contains('is-open')) {
      return;
    }

    this.search.classList.remove('is-open');
    this.search.setAttribute('aria-hidden', 'true');

    this.searchOpeners.forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
    });

    if (this.searchAbort) {
      this.searchAbort.abort();
      this.searchAbort = null;
    }

    unlockBodyIfPossible();

    if (restoreFocus !== false && this.lastFocus && document.contains(this.lastFocus)) {
      this.lastFocus.focus();
    }
  };

  Header.prototype.openMobile = function (trigger) {
    if (!this.mobile) return;

    this.closeMega();
    this.closeSearch(false);

    this.lastFocus =
      trigger ||
      document.activeElement;

    this.mobile.classList.add('is-open');
    this.mobile.setAttribute('aria-hidden', 'false');

    if (this.mobileOpen) {
      this.mobileOpen.setAttribute('aria-expanded', 'true');
    }

    lockBody();

    var first = focusable(this.mobile)[0];

    if (first) {
      window.setTimeout(function () {
        first.focus();
      }, 80);
    }
  };

  Header.prototype.closeMobile = function (restoreFocus) {
    if (!this.mobile || !this.mobile.classList.contains('is-open')) {
      return;
    }

    this.mobile.classList.remove('is-open');
    this.mobile.setAttribute('aria-hidden', 'true');

    if (this.mobileOpen) {
      this.mobileOpen.setAttribute('aria-expanded', 'false');
    }

    unlockBodyIfPossible();

    if (restoreFocus !== false && this.lastFocus && document.contains(this.lastFocus)) {
      this.lastFocus.focus();
    }
  };

  Header.prototype.trapFocus = function (event) {
    var activeContainer = null;

    if (this.search && this.search.classList.contains('is-open')) {
      activeContainer = this.search;
    } else if (this.mobile && this.mobile.classList.contains('is-open')) {
      activeContainer = this.mobile;
    }

    if (!activeContainer) return;

    var items = focusable(activeContainer);

    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  Header.prototype.updateScrollState = function () {
    this.root.classList.toggle('is-scrolled', window.scrollY > 24);
  };

  Header.prototype.setAnnouncement = function (index) {
    var count = this.announcementItems.length;

    if (!count) return;

    if (index < 0) index = count - 1;
    if (index >= count) index = 0;

    this.announcementIndex = index;

    this.announcementItems.forEach(function (item, itemIndex) {
      item.classList.toggle('is-active', itemIndex === index);
    });
  };

  Header.prototype.startAnnouncementRotation = function () {
    var self = this;

    if (this.announcementItems.length < 2) {
      return;
    }

    if (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      return;
    }

    this.announcementTimer = window.setInterval(function () {
      self.setAnnouncement(self.announcementIndex + 1);
    }, 5200);
  };

  Header.prototype.restartAnnouncementRotation = function () {
    if (this.announcementTimer) {
      window.clearInterval(this.announcementTimer);
      this.announcementTimer = null;
    }

    this.startAnnouncementRotation();
  };

  Header.prototype.onSearchInput = function () {
    var term = this.searchInput
      ? this.searchInput.value.trim()
      : '';

    if (term.length < 2) {
      if (this.searchDefault && this.searchResults) {
        this.searchResults.innerHTML = '';
        this.searchResults.appendChild(this.searchDefault.cloneNode(true));
      }

      return;
    }

    this.fetchPredictiveSearch(term);
  };

  Header.prototype.fetchPredictiveSearch = function (term) {
    var self = this;

    if (!this.searchResults) return;

    if (this.searchAbort) {
      this.searchAbort.abort();
    }

    this.searchAbort = new AbortController();

    this.searchResults.innerHTML =
      '<div class="lw-psearch__none"><span>Searching…</span></div>';

    var url =
      shopRoot() +
      'search/suggest?' +
      'q=' +
      encodeURIComponent(term) +
      '&resources[type]=product,collection,page' +
      '&resources[limit]=6' +
      '&resources[options][unavailable_products]=hide' +
      '&section_id=lw-predictive-search';

    fetch(url, {
      signal: this.searchAbort.signal,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Predictive search failed.');
        }

        return response.text();
      })
      .then(function (html) {
        var documentFragment =
          new DOMParser().parseFromString(html, 'text/html');

        var wrapper =
          documentFragment.querySelector('#shopify-section-lw-predictive-search');

        var results =
          wrapper
            ? wrapper.querySelector('#lw-predictive-search-results')
            : documentFragment.querySelector('#lw-predictive-search-results');

        if (!results) {
          self.searchResults.innerHTML =
            '<div class="lw-psearch__none"><span>No matches yet.</span><p>Try another product, concern or category.</p></div>';

          return;
        }

        self.searchResults.innerHTML = results.outerHTML;
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;

        console.error('[Livvewell Header] Search failed:', error);

        self.searchResults.innerHTML =
          '<div class="lw-psearch__none"><span>Search is temporarily unavailable.</span><p>Press Enter to view the full search page.</p></div>';
      });
  };

  Header.prototype.updateCartCount = function (count) {
    qsa(this.root, '[data-lw-cart-count]').forEach(function (badge) {
      badge.textContent = count || 0;
      badge.hidden = !count;
    });
  };

  Header.prototype.syncCartCount = function () {
    var self = this;

    fetch(shopRoot() + 'cart.js', {
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart count failed.');
        return response.json();
      })
      .then(function (cart) {
        self.updateCartCount(cart.item_count);
      })
      .catch(function () {});
  };

  function init(scope) {
    var container = scope || document;

    qsa(container, '[data-lw-header]').forEach(function (root) {
      new Header(root);
    });
  }

  API.init = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
